import React from 'react';
import { Box } from '@mui/material';
import {
  LocalFireDepartmentRounded,
  ChevronRightRounded,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { COLOR } from '@src/styles/color';
import Typography from '@src/new-components/Typography';
import { StyledFeaturedVoice } from './index.style';
import VoiceList from '../VoiceList';

const FeaturedVoice = ({
  onSeeAll,
  voicesList,
  onChangeVoice,
  onClose,
  isApplyPreset,
  isInitialLoading,
  isCommunity,
  onFetchFavouriteVoices,
  isDialog,
  favouriteVoiceCodes,
  onFavoriteToggleRequest,
  onHandleFavoriteProcessingComplete,
  onErrorProcessingFavouriteVoices,
  activeVoiceCode,
  prizes,
  isOpenFromSpeakerSettings = false,
}) => {
  const { t } = useTranslation();

  return (
    <StyledFeaturedVoice>
      <Box className="featured-voice-header" onClick={onSeeAll}>
        <LocalFireDepartmentRounded
          sx={{ color: COLOR.tagNew, fontSize: 24 }}
        />
        <Typography variant="body-20-bold" color={COLOR.darkGray}>
          {t('featuredVoice')}
        </Typography>
        <ChevronRightRounded
          sx={{ color: COLOR.indigo[80], fontSize: 24, cursor: 'pointer' }}
        />
      </Box>

      <VoiceList
        voices={voicesList}
        isCard
        isCommunity={isCommunity}
        onChangeVoice={onChangeVoice}
        onClose={onClose}
        isApplyPreset={isApplyPreset}
        isInitialLoading={isInitialLoading}
        onFetchFavouriteVoices={onFetchFavouriteVoices}
        isDialog={isDialog}
        favouriteVoiceCodes={favouriteVoiceCodes}
        onFavoriteToggleRequest={onFavoriteToggleRequest}
        onHandleFavoriteProcessingComplete={onHandleFavoriteProcessingComplete}
        onErrorProcessingFavouriteVoices={onErrorProcessingFavouriteVoices}
        activeVoiceCode={activeVoiceCode}
        prizes={prizes}
        isOpenFromSpeakerSettings={isOpenFromSpeakerSettings}
      />
    </StyledFeaturedVoice>
  );
};

export default FeaturedVoice;
